import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card mb-2" }
const _hoisted_2 = { class: "row m-2" }
const _hoisted_3 = { class: "col-12 col-md-4" }
const _hoisted_4 = { class: "col-12 mt-2" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Add DME Vendor ")
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "row p-2" }
const _hoisted_10 = { class: "col-12 d-flex" }
const _hoisted_11 = {
  key: 0,
  class: "col-12 col-md-6"
}
const _hoisted_12 = { class: "form-group row" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "medicare-number",
  class: "col-form-label col-12 col-md-5 text-md-end text-sm-start"
}, "Select DME ", -1 /* HOISTED */)
const _hoisted_14 = { class: "col-12 col-md-7" }
const _hoisted_15 = { class: "col-12" }
const _hoisted_16 = { class: "table table-responsive-md border border-gray" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-table-header" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Equipment Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Infusion Pump"),
    /*#__PURE__*/_createElementVNode("th", null, "Start Date"),
    /*#__PURE__*/_createElementVNode("th", null, "End Date"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-end" }, "Actions")
  ])
], -1 /* HOISTED */)
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PatientVendor = _resolveComponent("PatientVendor")!
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_TableEmpty = _resolveComponent("TableEmpty")!
  const _component_DMETableRow = _resolveComponent("DMETableRow")!
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_FormSection, {
      title: "DME",
      "full-height": false
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.patientVendors, (vendor, index) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_PatientVendor, {
                "vendor-id": _ctx.patientVendors[index],
                "onUpdate:vendor-id": ($event: any) => ((_ctx.patientVendors[index]) = $event),
                "provider-id": _ctx.providerId,
                "patient-vendors": _ctx.patientVendors,
                "onUpdate:patient-vendors": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.patientVendors) = $event)),
                "vendor-types": _ctx.vendorTypes,
                "card-title": "DME Vendor"
              }, null, 8 /* PROPS */, ["vendor-id", "onUpdate:vendor-id", "provider-id", "patient-vendors", "vendor-types"])
            ]))
          }), 256 /* UNKEYED_FRAGMENT */)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "btn btn-outline-primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addNewVendor())),
              disabled: !!_ctx.patientVendors && _ctx.patientVendors.length >= 5
            }, _hoisted_8, 8 /* PROPS */, _hoisted_5)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            (!_ctx.isEditAllowed)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-primary btn-xs ms-auto mb-2",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateDmes()))
                }, " Update DME "))
              : _createCommentVNode("v-if", true)
          ]),
          (_ctx.isEditAllowed)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_TypeaheadInput, {
                      getData: _ctx.getDMEList,
                      value: _ctx.selectionDme,
                      disabled: _ctx.showDmeInputRow,
                      "open-on-focus": true,
                      onValueChanged: _ctx.selectionDmeChanged
                    }, null, 8 /* PROPS */, ["getData", "value", "disabled", "onValueChanged"])
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("table", _hoisted_16, [
              _hoisted_17,
              _createCommentVNode(" EMPTY "),
              (_ctx.dmes.length == 0 && !_ctx.showDmeInputRow)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_18, [
                    _createVNode(_component_TableEmpty, {
                      "col-span": _ctx.columns,
                      component: "dme",
                      "secondary-message": "No DME Added"
                    }, null, 8 /* PROPS */, ["col-span"])
                  ]))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" NEW "),
              (_ctx.showDmeInputRow)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_19, [
                    _createVNode(_component_DMETableRow, {
                      dme: _ctx.savetoAdd,
                      "is-new-dme": true,
                      "update-dme": _ctx.saveNewDme,
                      "cancel-new-dme": _ctx.cancelNewDme,
                      columns: _ctx.columns
                    }, null, 8 /* PROPS */, ["dme", "update-dme", "cancel-new-dme", "columns"])
                  ]))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" DATA "),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dmes, (dme) => {
                return (_openBlock(), _createElementBlock("tbody", null, [
                  _createVNode(_component_DMETableRow, {
                    dme: dme,
                    "update-dme": _ctx.updateDme,
                    "delete-dme-from-list": _ctx.deleteDmeFromList
                  }, null, 8 /* PROPS */, ["dme", "update-dme", "delete-dme-from-list"])
                ]))
              }), 256 /* UNKEYED_FRAGMENT */))
            ])
          ])
        ])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}